import { render, staticRenderFns } from "./fball-counter.vue?vue&type=template&id=22d47d61&scoped=true"
import script from "./fball-counter.vue?vue&type=script&lang=js"
export * from "./fball-counter.vue?vue&type=script&lang=js"
import style0 from "./fball-counter.vue?vue&type=style&index=0&id=22d47d61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d47d61",
  null
  
)

export default component.exports